<template>
  <div>
    <ts-page-title :title="$t('driverProfile.pageTitle')" :breadcrumb="[
      { text: $t('home'), href: '/' },
      {
        text: $t('driverProfile.pageTitle'),
        active: true,
      },
    ]" />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="tw-flex tw-justify-between tw-items-center">
          <div class="tw-space-x-2">
            <a-button type="primary" @click="addNew">
              {{ $t("addNew") }}
            </a-button>
            <a-button type="info" @click.prevent="onViewTelegramId">
              {{ $t("driverProfile.viewTelegramChatId") }}
            </a-button>
          </div>
          <div class="tw-space-x-3">
            <a-radio-group v-model="isInternalDriver" @change="fetchData()">
              <a-radio-button :value="undefined">
                {{ $t("driverProfile.all") }}
              </a-radio-button>
              <a-radio-button :value="1">
                {{ $t("driverProfile.internal") }}
              </a-radio-button>
              <a-radio-button :value="0">
                {{ $t("driverProfile.external") }}
              </a-radio-button>
            </a-radio-group>
            <a-radio-group v-model="isActive" @change="fetchData()">
              <a-radio-button :value="undefined">
                {{ $t("driverProfile.all") }}
              </a-radio-button>
              <a-radio-button :value="1">
                {{ $t("driverProfile.active") }}
              </a-radio-button>
              <a-radio-button :value="0">
                {{ $t("driverProfile.inactive") }}
              </a-radio-button>
            </a-radio-group>
            <a-tooltip :title="$t('driverProfile.search')">
              <a-input-search v-model="search" :placeholder="$t('driverProfile.search')" style="width: 200px" />
            </a-tooltip>
          </div>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-x-scroll">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.driver_code }}</td>
            <td>{{ record.driver_name }}</td>
            <td class="tw-text-center">{{ record.sex }}</td>
            <td>{{ record.dob }}</td>
            <td>
              {{ record.phone1 }} |{{ record.phone2 }} | {{
                record.phone3
              }}
            </td>
            <td>
              Start: {{ record.contract_start_date }} | End:
              {{ record.contract_end_date }}
            </td>
            <td>{{ record.vehicle_types }}</td>
            <td>{{ record.plat_number }}</td>
            <td>{{ record.agency_name }}</td>
            <td class="tw-text-right">
              {{ record.tel_chat_id }}
            </td>
            <td class="tw-text-center">
              <span class="badge bg-primary" v-if="record.is_internal_driver">Yes</span>
              <span class="badge bg-secondary" v-else>No</span>
            </td>
            <td class="tw-text-center">
              <span class="badge bg-primary" v-if="record.is_active">Yes</span>
              <span class="badge bg-secondary" v-else>No</span>
            </td>
            <td class="text-center tw-space-x-3">
              <a href="#" v-tooltip="$t('edit')" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-panel>
    <a-modal v-if="showModalTelegram" v-model="showModalTelegram" :title="$t('shop.viewTelegramChatId')" :footer="null"
      width="50%">
      <ts-loading-banner :loading="telegramWaiting">
        <label class="required">{{ $t("driverProfile.driverName") }}</label>
        <a-select v-model="model.driver_id" :options="driverProfiles" class="tw-w-full" showSearch
          @search="searchDriver" :default-active-first-option="false" :filter-option="false" :not-found-content="null"
          :placeholder="$t('driverProfile.driverName')" />
        <div class="tw-text-red-600" v-if="errors.has('driver_id')">
          {{ errors.first("driver_id") }}
        </div>
        <div class="tw-border tw-p-2 tw-rounded tw-mt-3 tw-overflow-x-scroll" v-if="telegramsRecord.length">
          <a-input v-model="searchTelegram" class="tw-w-full" placeholder="Search"></a-input>

          <table class="tw-w-full tw-mt-2">
            <tr v-for="(telegram, index) in telegramsRecordList" :key="index">
              <td class="tw-p-1 ">
                {{ index + 1 }}
              </td>
              <td class="tw-p-1 ">
                <span class="tw-bg-black tw-px-2 tw-rounded tw-text-white">{{ telegram.id }}</span>
              </td>
              <td class="tw-p-1  tw-whitespace-nowrap tw-overflow-hidden">
                <b>{{ telegram.title }}</b>
              </td>
              <td class="tw-p-1  tw-text-right">
                <ts-button class="tw-whitespace-nowrap" :disabled="!model.driver_id"
                  @click.prevent="onUpdateChatId(telegram)">
                  <i class="fas fa-link"></i>
                  {{ $t("shop.connectTelegram") }}
                </ts-button>
              </td>
            </tr>
          </table>
        </div>
      </ts-loading-banner>
    </a-modal>

  </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { debounce } from "lodash";
import { mapState } from "vuex";
import { mapActions } from "vuex/dist/vuex.common.js";

export default {
  name: "driverProfile",
  data() {
    return {
      errors: new Errors(),
      loading: false,
      telegramWaiting: false,
      showModalTelegram: false,
      telegramsRecord: [],
      searchTelegram: '',
      driverProfiles: [],
      model: {
        driver_id: undefined,
        tel_chat_id: undefined
      }
    };
  },
  computed: {
    ...mapState("driver/driverProfile", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.driver.driverProfile.search;
      },
      set(newValue) {
        this.$store.commit("driver/driverProfile/SET_SEARCH", newValue);
        this.$store.commit("driver/driverProfile/RESET_CURRENT_PAGE");
      },
    },
    isActive: {
      get() {
        return this.$store.state.driver.driverProfile.isActive;
      },
      set(newValue) {
        this.$store.commit("driver/driverProfile/SET_ACTIVE", newValue);
      },
    },
    isInternalDriver: {
      get() {
        return this.$store.state.driver.driverProfile.is_internal_driver;
      },
      set(newValue) {
        this.$store.commit("driver/driverProfile/SET_IS_INTERNAL", newValue);
      },
    },
    columns() {
      return [
        { name: this.$t("driverProfile.driverCode"), sortKey: 'driver_code' },
        { name: this.$t("driverProfile.driverName"), sortKey: 'driver_name' },
        { name: this.$t("driverProfile.sex"), sortKey: 'sex' },
        { name: this.$t("driverProfile.dateOfBirth"), sortKey: 'dob' },
        { name: this.$t("driverProfile.phoneNumber") },
        { name: this.$t("driverProfile.contractStartDate"), sortKey: 'contract_start_date' },
        { name: this.$t("driverProfile.vehicleType") },
        { name: this.$t("driverProfile.platNumber") },
        { name: this.$t("driverProfile.agency") },
        { name: this.$t("driverProfile.telChatId") },
        {
          name: this.$t("driverProfile.internalDriver"),
          style: "text-align:center",
        },
        {
          name: this.$t("driverProfile.active"),
          style: "text-align:center",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 1px;",
        },
      ];
    },
    telegramsRecordList() {
      return this.telegramsRecord
        .filter(t => t.type === "group")
        .filter(
          t =>
            t.title
              .toLowerCase()
              .indexOf(this.searchTelegram.toLowerCase()) >= 0
        );
    },
  },
  methods: {
    ...mapActions('driver/driverProfile', ['getFormViewData', 'updateTelegramChatId']),
    searchDriver: debounce(async function (search, force = false) {
      if (!search && !force) return;
      this.loading = true
      await this.getFormViewData({
        params: {
          fnName: 'driverNoAssignTel',
          search
        }
      })
        .then(({ data }) => {
          this.driverProfiles = data.driverNoAssignTel.map(el => ({
            value: el.driver_id,
            label: `${el.driver_code}-${el.driver_name}`
          }))
        })
        .catch(err => {
          this.$notify({ type: 'error', text: err.message })
        })
        .finally(() => {
          this.loading = false
        })
    }, 500),
    addNew() {
      this.$router.push({ name: "driver-profile-create" });
    },
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("driver/driverProfile/fetch", { ...attributes })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    edit(record) {
      this.$store.commit("driver/driverProfile/SET_EDIT_DATA", record);
      this.$router.push({
        name: "driver-profile-edit",
        params: { id: record.driver_id },
      });
    },
    async fetchTelegram() {
      return this.$store
        .dispatch("driver/driverProfile/viewTelegramChatId")
        .then(res => {
          this.telegramsRecord = res;
        })
        .catch(error => {
          this.$notify({ type: "error", text: error.message });
        })
    },
    async onViewTelegramId() {
      this.telegramWaiting = true;
      this.showModalTelegram = true;
      this.telegramsRecord = [];
      this.model.driver_id = undefined;
      if(!this.driverProfiles.length) {
        this.searchDriver('', true)
      }
      await this.fetchTelegram()
        .finally(() => (this.telegramWaiting = false));
    },
    onUpdateChatId(record) {
      this.telegramWaiting = true;
      this.model.tel_chat_id = record.id;
      this.updateTelegramChatId(this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.model.driver_id = undefined;
          await this.fetchTelegram()
        })
        .catch(error => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => (this.telegramWaiting = false));
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("driver/driverProfile/RESET_STATE");
    next();
  },
};
</script>
